var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordianIconOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.933c6.627 0 12-5.358 12-11.967C25 6.358 19.627 1 13 1S1 6.358 1 12.966c0 6.61 5.373 11.967 12 11.967zM8.201 12.966h9.6",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMyAyNC45MzI4QzE5LjYyNzQgMjQuOTMyOCAyNSAxOS41NzUzIDI1IDEyLjk2NjRDMjUgNi4zNTc1NCAxOS42Mjc0IDEgMTMgMUM2LjM3MjU4IDEgMSA2LjM1NzU0IDEgMTIuOTY2NEMxIDE5LjU3NTMgNi4zNzI1OCAyNC45MzI4IDEzIDI0LjkzMjhaIiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik04LjIwMTE3IDEyLjk2NjRIMTcuODAxMSIgc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==";
export { SvgAccordianIconOpen as ReactComponent };